// export const HOST_NAME = 'https://keshetteamimsignage.keshet-teamim.co.il/';
// export const HOST_NAME = 'https://kt.xcircular.com/';
export const HOST_NAME = 'https://keshetteamimsignage.keshet-teamim.co.il/';
export const QA_HOST_NAME = 'https://kt.xcircular.com/';
export const LOCAL_DEV_HOST_NAME = 'https://xcserver.xcircular.com/';
export const PROD_HOST_NAME = 'https://keshetteamimsignage.keshet-teamim.co.il/';
export const VERSION = "3.11.5";
export const FULL_VERSION = "3.11.5.A";
export const BUILD = "20220830.201000";